import { Reveal } from "@/components/Reveal";
import { TESTIMONIALS_INTRO } from "@/data/content";

export const TestimonialsSection = ({ testimonials }) => {
  const list = testimonials || [];
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="section"
      style={{ backgroundColor: "var(--bg)" }}
    >
      <div className="container-fx">
        <div className="grid gap-8 lg:grid-cols-2 lg:items-end">
          <Reveal>
            <div>
              <p className="eyebrow">{TESTIMONIALS_INTRO.eyebrow}</p>
              <h2
                className="display mt-5"
                style={{ fontSize: "clamp(2.4rem, 6vw, 4.4rem)", fontWeight: 500 }}
              >
                {TESTIMONIALS_INTRO.headline_lead}
                <br />
                <span className="accent-italic">
                  {TESTIMONIALS_INTRO.headline_accent}
                </span>
              </h2>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <p
              className="max-w-md lg:pb-3"
              style={{ color: "var(--text-2)", fontSize: "1rem", lineHeight: 1.7 }}
            >
              {TESTIMONIALS_INTRO.body}
            </p>
          </Reveal>
        </div>

        {/* Masonry */}
        <div
          className="mt-14"
          style={{ columnGap: "1.5rem" }}
          data-testid="testimonials-grid"
        >
          <style>{`
            .tcols { column-count: 1; }
            @media (min-width: 768px) { .tcols { column-count: 2; } }
            @media (min-width: 1024px) { .tcols { column-count: 3; } }
          `}</style>
          <div className="tcols" style={{ columnGap: "1.5rem" }}>
            {list.map((t, i) => (
              <div
                key={t.id || i}
                data-testid={`testimonial-card-${i}`}
                className="mb-6 break-inside-avoid"
                style={{
                  backgroundColor: t.featured
                    ? "var(--surface-3)"
                    : "var(--surface)",
                  border: "1px solid var(--border-c)",
                  borderRadius: "var(--radius-lg)",
                  padding: "1.8rem",
                }}
              >
                <span
                  className="font-serif block"
                  style={{
                    color: "var(--bronze)",
                    fontSize: "2.6rem",
                    lineHeight: 0.6,
                    opacity: 0.5,
                    height: "1.2rem",
                  }}
                  aria-hidden="true"
                >
                  &ldquo;
                </span>
                <p
                  className="font-serif"
                  style={{
                    fontStyle: "italic",
                    color: "var(--text)",
                    fontSize: t.featured ? "1.18rem" : "1.02rem",
                    lineHeight: 1.55,
                  }}
                >
                  {t.quote}
                </p>
                <div
                  className="mt-5 flex items-center gap-3"
                  style={{ paddingTop: "0.4rem" }}
                >
                  <span
                    style={{
                      width: 22,
                      height: 1,
                      backgroundColor: "var(--bronze)",
                    }}
                  />
                  <span
                    style={{
                      fontFamily: "var(--font-sans)",
                      color: "var(--text)",
                      fontSize: "0.82rem",
                      fontWeight: 600,
                      letterSpacing: "0.04em",
                    }}
                  >
                    {t.name}
                  </span>
                  {t.label ? (
                    <span
                      style={{
                        fontFamily: "var(--font-sans)",
                        textTransform: "uppercase",
                        letterSpacing: "0.16em",
                        fontSize: "0.6rem",
                        color: "var(--muted-2)",
                      }}
                    >
                      {t.label}
                    </span>
                  ) : null}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
